export default __webpack_public_path__ + "assets/marker-pin-selected.db0d0242.svg";